import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { createStructuredSelector } from 'reselect';

import {
	COMPANIES_CREATE,
	COMPANIES_CREATE_SUCCESS,
	COMPANIES_CREATE_FAIL,
	COMPANIES_UPDATE,
	COMPANIES_UPDATE_SUCCESS,
	COMPANIES_UPDATE_FAIL,
	COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	COMPANIES_GET_DETAILS,
	COMPANIES_GET_DETAILS_SUCCESS,
	COMPANIES_GET_DETAILS_FAIL,
	OPTIONS_GET,
	OPTIONS_GET_SUCCESS,
	OPTIONS_GET_FAIL,
} from 'Constants/actionTypes';

const statusReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COMPANIES_CREATE:
	case COMPANIES_UPDATE:
		return state.set('company', 'submitting');
	case COMPANIES_CREATE_SUCCESS:
	case COMPANIES_UPDATE_SUCCESS:
		return state.set('company', 'submitted');
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state.set('companies', 'fetching');
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return state.set('companies', 'fetched');
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL:
		return state.set('companies', 'has-errors');
	case COMPANIES_GET_DETAILS:
		return state.set('company', 'fetching');
	case COMPANIES_GET_DETAILS_SUCCESS:
		return state.set('company', 'fetched');
	case COMPANIES_CREATE_FAIL:
	case COMPANIES_UPDATE_FAIL:
	case COMPANIES_GET_DETAILS_FAIL:
		return state.set('company', 'has-errors');
	case OPTIONS_GET:
		return action.payload.tag === 'company' ? state.set('options', 'fetching') : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'company' ? state.set('options', 'fetched') : state;
	case OPTIONS_GET_FAIL:
		return action.payload.tag === 'company' ? state.set('options', 'has-errors') : state;
	default:
		return state;
	}
};

const currentReducer = (state = null, action) => {
	switch (action.type) {
	case COMPANIES_CREATE:
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return null;
	case COMPANIES_CREATE_SUCCESS:
	case COMPANIES_UPDATE_SUCCESS:
	case COMPANIES_GET_DETAILS_SUCCESS:
		return action.payload.id;
	default:
		return state;
	}
};

const companiesByPageReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state;
	case COMPANIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return new Map(action.payload);
	default:
		return state;
	}
};

const companyReducer = (state = new Map(), action) => {
	switch (action.type) {
	case COMPANIES_GET_DETAILS:
		return new Map();
	case COMPANIES_CREATE_SUCCESS:
	case COMPANIES_UPDATE_SUCCESS:
	case COMPANIES_GET_DETAILS_SUCCESS:
		return state.set(action.payload.id, action.payload);
	default:
		return state;
	}
};

const optionsReducer = (state = new Map(), action) => {
	switch (action.type) {
	case OPTIONS_GET:
		return action.payload.tag === 'company' ? new Map() : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'company' ? new Map(action.payload.options) : state;
	default:
		return state;
	}
};

export default combineReducers({
	status          : statusReducer,
	current         : currentReducer,
	companiesByPage : companiesByPageReducer,
	company         : companyReducer,
	options         : optionsReducer,
});

export const selector = createStructuredSelector({
	status          : (state) => state.companies.status,
	current         : (state) => state.companies.current,
	companiesByPage : (state) => state.companies.companiesByPage,
	company         : (state) => state.companies.company,
	options         : (state) => state.companies.options,
	errors          : (state) => state.errors.get('company'),
});